import { render, staticRenderFns } from "./AppLesson.vue?vue&type=template&id=517035ae&scoped=true&"
import script from "./AppLesson.vue?vue&type=script&lang=js&"
export * from "./AppLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517035ae",
  null
  
)

export default component.exports